module.exports = __webpack_public_path__ + "static/media/logo-snoop.f9274a7d.png";